import React from 'react';
import {
  CommerceHeader,
  CommerceSearch,
  Footer
} from '../../components'
import MainLayout from '../../layouts/main-layout/main-layout';
import { useParams } from 'react-router-dom';

import classes from './comercios.module.css';

function ComerciosPage() {
  let { hide } = useParams();
  return (
    <>
    {
      !hide &&
      <MainLayout />
    }
      
      <div className={classes.contentComercios}>
        <CommerceHeader />
        <CommerceSearch />
      </div>
    {
      !hide &&
      <Footer />
    }
    </>
    
  );
}

export default ComerciosPage;